import { render, staticRenderFns } from "./PlateValidationModal.vue?vue&type=template&id=0c8adf22&scoped=true"
import script from "./PlateValidationModal.vue?vue&type=script&lang=js"
export * from "./PlateValidationModal.vue?vue&type=script&lang=js"
import style0 from "./PlateValidationModal.vue?vue&type=style&index=0&id=0c8adf22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8adf22",
  null
  
)

export default component.exports